import { useState, useEffect } from 'react';
import ServiceCard from './ServiceCard';
import { serviceAPI } from '../services/serviceService';

function FeaturedServices() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFeaturedServices = async () => {
      try {
        setLoading(true);
        const data = await serviceAPI.getFeaturedServices();
        setServices(data);
        setError(null);
      } catch (err) {
        console.error('Öne çıkan hizmetler yüklenirken hata:', err);
        setError('Öne çıkan hizmetler yüklenirken bir hata oluştu.');
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedServices();
  }, []);

  if (loading) {
    return (
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
            <p className="mt-4 text-gray-600">Hizmetler yükleniyor...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Hizmetlerimiz</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Profesyonel ekibimizle sunduğumuz kaliteli hizmetler. Güvenilir ve deneyimli uzmanlarımızla yanınızdayız.
          </p>
          {error && (
            <div className="mt-4 p-3 bg-red-100 text-red-700 rounded-md">
              {error}
            </div>
          )}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <ServiceCard key={service.id} service={service} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeaturedServices;
